import React from 'react';
import { ViewerEnvironmentContext } from './environment';
import type { ViewerEnvironment } from './environment';

interface ViewerErrorBoundaryProps {
  fallback: React.ReactNode;
  fileName?: string;
  children: React.ReactNode;
}

interface ViewerErrorBoundaryState {
  hasError: boolean;
}

// three.js throws synchronously on exotic geometry or a hostile GPU driver;
// without a boundary that unmounts everything around the viewer.
export default class ViewerErrorBoundary extends React.Component<
  ViewerErrorBoundaryProps,
  ViewerErrorBoundaryState
> {
  static readonly contextType = ViewerEnvironmentContext;
  declare context: ViewerEnvironment;
  state: ViewerErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ViewerErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error('[ModelViewer] Render crash contained:', error);
    this.context.onError?.(error, {
      label: 'ModelViewer',
      fileName: this.props.fileName,
      stage: 'render',
      componentStack: errorInfo.componentStack,
    });
  }

  render(): React.ReactNode {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}
